/**
 * sticky-atc.js
 * Sticky Add-to-Cart bar for Empire theme — mobile only (< 768px).
 *
 * Behaviour:
 *  - Hidden until the original [data-product-atc] button scrolls out of view.
 *  - Slides in from the bottom on mobile only.
 *  - Syncs price and availability with Empire's variant-change events.
 *  - Clicking the sticky button delegates to the original ATC button so all
 *    Empire cart logic (loading state, drawer, quantity) runs as normal.
 */

(function () {
  'use strict';

  // Only run on product pages and only on mobile viewports
  const bar = document.querySelector('[data-sticky-atc]');
  if (!bar) return;

  const stickyBtn     = bar.querySelector('[data-sticky-atc-btn]');
  const stickyBtnText = bar.querySelector('[data-sticky-atc-btn-text]');
  const stickyPrice   = bar.querySelector('[data-sticky-atc-price]');

  // Original ATC button rendered by product-form.liquid
  const originalBtn   = document.querySelector('[data-product-atc]');
  if (!originalBtn) return;

  // Empire's variant-selection custom element (fires 'variant-change')
  const variantSelection = document.querySelector('[data-variant-selection]');

  // ── Visibility via IntersectionObserver ──────────────────────────────────
  const isMobile = () => window.innerWidth < 768;

  const observer = new IntersectionObserver(
    function (entries) {
      if (!isMobile()) {
        hideBar();
        return;
      }
      const entry = entries[0];
      if (!entry.isIntersecting) {
        showBar();
      } else {
        hideBar();
      }
    },
    {
      root: null,
      threshold: 0,
      rootMargin: '0px 0px -20px 0px'
    }
  );

  observer.observe(originalBtn);

  function showBar() {
    bar.classList.add('sticky-atc-bar--visible');
    bar.setAttribute('aria-hidden', 'false');
  }

  function hideBar() {
    bar.classList.remove('sticky-atc-bar--visible');
    bar.setAttribute('aria-hidden', 'true');
  }

  window.addEventListener('resize', function () {
    if (!isMobile()) hideBar();
  });

  // ── Delegate click to original ATC button ────────────────────────────────
  stickyBtn.addEventListener('click', function () {
    if (stickyBtn.disabled) return;
    originalBtn.click();
  });

  // ── Sync variant state from Empire's variant-change events ───────────────
  if (variantSelection) {
    variantSelection.addEventListener('variant-change', function (event) {
      var detail  = event.detail || {};
      var variant = detail.variant;
      var state   = detail.state;

      if (variant && variant.price) {
        stickyPrice.textContent = formatMoney(variant.price);
      }

      var available = variant && variant.available;
      var soldOut   = !available;

      if (soldOut || state === 'unavailable') {
        stickyBtn.disabled = true;
        stickyBtn.classList.add('sticky-atc-bar__btn--disabled');
        stickyBtnText.textContent = getSoldOutText();
      } else {
        stickyBtn.disabled = false;
        stickyBtn.classList.remove('sticky-atc-bar__btn--disabled');
        stickyBtnText.textContent = getAddToCartText();
      }
    });
  }

  // ── Money formatting ──────────────────────────────────────────────────────
  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat);
    }
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars;
  }

  // ── Text helpers ──────────────────────────────────────────────────────────
  function getAddToCartText() {
    var span = originalBtn.querySelector('.atc-button--text');
    return span ? span.textContent.trim() : 'Add to Cart';
  }

  function getSoldOutText() {
    var span = originalBtn.querySelector('.atc-button--text');
    if (span && originalBtn.disabled) return span.textContent.trim();
    return 'Sold Out';
  }

})();